import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Alert, Card, Checkbox, Col, Flex, Row, Tag, Typography } from 'antd';
import * as _ from 'underscore';

class Points extends Component {
    constructor(props) {
        super(props);
        this.state={
            computedList:[
                {
                    elements:['Wood'],
                    points:['LU11', 'LR4', 'GB44'] 
                },
                {
                    elements:['Water'],
                    points:['ST44', 'BL40', 'KI3', 'SP9'] 
                },
                {
                    elements:['Air'],
                    points:['LUIO', 'TE1', 'HT4', 'SI1', 'PC5', '4I5'] 
                },
                {
                    elements:['Earth'],
                    points:['SP1', 'LR3', 'GB34', 'SI43'] 
                },
                {
                    elements:['Fire'],
                    points:['TE2' , 'BL60', 'HT3', 'SI5', 'PC3', 'KI2'] 
                },
                {
                    elements:['Wood','Air'],
                    points:['LU11','LR4','GB44']
                },
                {
                    elements:['Wood','Earth'],
                    points:['SP1','LR4','GB34','ST43'] 
                },
                {
                    elements:['Wood','Fire'],
                    points:['PC9', 'HT9', 'SI3', 'TE3', 'LR2', 'GB38'] 
                },
                {
                    elements:['Water','Air'],
                    points:['LU5', 'BL67', 'LI2', 'KI7'] 
                },
                {
                    elements:['Earth','Water'],
                    points:['ST44', 'BL40', 'KI3', 'SP9'] 
                },
                {
                    elements:['Water','Fire'],
                    points:['TE2', 'BL6O', 'HT3', 'SI5', 'PC3', 'KI2'] 
                },
                {
                    elements:['Wood','Water'],
                    points:['KI1', 'BL65', 'LR8', 'GB43'] 
                },
                {
                    elements:['Air','Earth'],
                    points:['LU9', 'LI11', 'SP5', 'ST45'] 
                },
                {
                    elements:['Air','Fire'],
                    points:['LUI0', 'TE1', 'HT4', 'SI1', 'PC5', 'LI5'] 
                },
                {
                    elements:['Earth','Fire'],
                    points:['SP2', 'ST41', 'HT7', 'SI8', 'PC7', 'TE10'] 
                },
                {
                    elements:['Earth','Air','Water'],
                    points:['LU9', 'LI1', 'SP5', 'ST45'] 
                },
                {
                    elements:['Water','Earth','Wood'],
                    points:['ST44', 'SP9'] 
                },
                {
                    elements:['Air','Water','Wood','Fire'],
                    points:['ST45','SB5'] 
                },
            ],
            finalPoints:[]
        }
    }


    componentDidMount() {

    }



    componentDidUpdate(prevProps, prevState) {

    }

   
    getColor = () =>{
        let color = ['success', 'warning', 'info']
        const random = Math.floor(Math.random() * color.length);
        return(color[random])
    }
    filterByElements=(computedList, searchElements)=> {
        return computedList.filter(item => {
            // Normalize elements to an array of strings
            const itemElements = Array.isArray(item.elements) 
                ? item.elements 
                : item.elements.split(',');
    
            // Check if both arrays have the same length and all elements match
            return itemElements.length === searchElements.length &&
                   searchElements.every(el => itemElements.includes(el));
        });
    }
    getPoints=(checkedValues)=>{
        const filteredList = this.filterByElements(this.state.computedList, checkedValues);
        console.log("POINTS",filteredList)
        let points = []
        filteredList.map((ele)=>{
            points.push(...ele.points);
        })
        this.setState({
            finalPoints:points
        })
    }
    render() {
        return (
            <div>
                <Flex gap="middle" justify='center' align='center'>

                    <Card
                        style={{
                            marginTop: 16,
                            width: '100%'
                        }}
                        type="inner"
                        title="Select missing elements to get touch points"

                    >
                        <Flex vertical justify='center' align='center'>
                            <Checkbox.Group style={{ width: '100%'}} onChange={this.getPoints}>
                                <Row>
                                    <Col sm={12} lg={8}>
                                        <Checkbox style={{fontSize:'16px' }} value="Air">Air</Checkbox>
                                    </Col>
                                    <Col sm={12} lg={8}>
                                        <Checkbox style={{fontSize:'16px' }} value="Water">Water</Checkbox>
                                    </Col>
                                    <Col sm={12} lg={8}>
                                        <Checkbox style={{fontSize:'16px' }} value="Earth">Earth</Checkbox>
                                    </Col>
                                    <Col sm={12} lg={8}>
                                        <Checkbox style={{fontSize:'16px' }} value="Wood">Wood</Checkbox>
                                    </Col>
                                    <Col sm={12} lg={8}>
                                        <Checkbox style={{fontSize:'16px' }} value="Fire">Fire</Checkbox>
                                    </Col>
                                </Row>
                            </Checkbox.Group>

                            <Card
                                style={{ width: '100%', marginTop: '25px' }}
                            >
                                <Typography.Title style={{ marginTop: 0 }} level={5}>Touch Points</Typography.Title>
                                <Flex gap="6px" wrap>
                                    {this.state.finalPoints.length > 0 ? <>
                                        {this.state.finalPoints.map((point,index)=>{
                                        return(<Alert key={index} message={point} type={this.getColor()} />)
                                    })}</> : 'Not Available'}
                                    
                                                               
                                </Flex>
                            </Card>
                        </Flex>

                    </Card>

                </Flex>
            </div>
        );
    }
}



export default Points;